import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import styles from "./MenuLayoutEdit.module.css";
import { useEffect, useState } from "react";
import getJsonFromApi from "../../../Common/getJsonFromApi";

export default function AddMenuItemDialog(props) {
  const { onCancel, onAdd } = props;
  const [menuItems, setMenuItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedItem, setSelectedItem] = useState({});
  const sortAscending = 1;
  const [sort, setSort] = useState({ column: 0, direction: sortAscending });
  const sortCompare = (a, b) => {
    const { direction, column } = sort;
    const itemName = a.itemName.localeCompare(b.itemName) * direction;
    const category = a.categoryName.localeCompare(b.categoryName) * direction;
    if (column === 0) {
      return itemName;
    } else {
      return category === 0 ? itemName : category;
    }
  };
  const getSortIcon = (show, direction) => {
    return show ? (
      direction === sortAscending ? (
        <span className="k-icon k-i-sort-asc-sm" />
      ) : (
        <span className="k-icon k-i-sort-desc-sm" />
      )
    ) : undefined;
  };
  const toggleSort = (column) => {
    const newDirection =
      column === sort.column ? -sort.direction : sortAscending;
    setSort({ column, direction: newDirection });
  };
  const filter = (item) => {
    const term = (searchTerm || "").toLocaleLowerCase();
    const category = (item.categoryName || "").toLocaleLowerCase();
    const itemName = (item.itemName || "").toLocaleLowerCase();
    return (
      item.isActive &&
      !item.isDeleted &&
      (itemName.includes(term) || category.includes(term))
    );
  };
  const onClickItem = (e, item) => {
    e.preventDefault();
    setSelectedItem(item);
  };
  useEffect(() => {
    getJsonFromApi("/MenuItems").then((items) => {
      setMenuItems(items);
    });
  }, []);
  return (
    <Dialog
      title={<span className={styles.dialogTitle}>Add Menu Items</span>}
      onClose={onCancel}
    >
      <div className={styles.search}>
        <span className={`${styles.searchIcon} k-icon k-i-search`}></span>
        <input
          className={styles.searchInput}
          type="text"
          placeholder="Search..."
          onChange={(e) => setSearchTerm(e.target.value)}
        ></input>
        <div className={styles.searchResults}>
          <table className="table">
            <thead>
              <tr>
                <th
                  role="button"
                  aria-label="Toggle sort by name"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSort(0);
                  }}
                >
                  Name
                  {getSortIcon(sort.column === 0, sort.direction)}
                </th>
                <th
                  role="button"
                  aria-label="Toggle sort by category"
                  style={{ cursor: "pointer" }}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleSort(1);
                  }}
                >
                  Category
                  {getSortIcon(sort.column === 1, sort.direction)}
                </th>
              </tr>
            </thead>
            <tbody>
              {menuItems
                .filter(filter)
                .sort(sortCompare)
                .map((item, index) => (
                  <tr
                    role="button"
                    aria-label={`Select ${item.itemName} from ${item.categoryName}`}
                    key={index}
                    className={
                      item.id === selectedItem.id ? styles.selectedItem : ""
                    }
                    style={{ cursor: "pointer" }}
                    onClick={(e) => onClickItem(e, item)}
                  >
                    <td>{item.itemName}</td>
                    <td>
                      <span
                        className={styles.dot}
                        style={{ backgroundColor: item.color }}
                      />
                      {item.categoryName}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <DialogActionsBar>
        <button
          aria-label="Add"
          className={`btn blue btn-lg margleft10 defaultBtnClass ${
            styles.button
          } ${!selectedItem.id ? "disabled" : ""}`}
          onClick={(e) => {
            e.preventDefault();
            onAdd(selectedItem);
          }}
        >
          Add
        </button>
        <button
          aria-label="Cancel add menu item"
          className={`btn default btn-lg not-default-btn ${styles.button}`}
          onClick={onCancel}
        >
          Cancel
        </button>
      </DialogActionsBar>
    </Dialog>
  );
}
